import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { Subject } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public isUserDataReceived = new Subject<boolean>();
  public isUserDataReceived$ = this.isUserDataReceived.asObservable();

  constructor(
    private keycloak: Keycloak,
    private ls: LocalStorageService
  ) {}

  logout() {
    this.ls.clear();
    this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
